import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns';
import { CheckBoxSelectionService } from '@syncfusion/ej2-angular-dropdowns';
import { Title, Meta } from '@angular/platform-browser';
import { NgxLinkifyOptions } from 'ngx-linkifyjs-v2';
import { Subscription } from 'rxjs';
import { Category, Subcategory, User, UserService } from '../../core';
import { LoaderService } from '../../core/loader.service';
import { Profile } from '../../core/models/profile.model';
import { Review } from '../../core/models/review.model';
import { AuthService } from '../../core/services/auth.service';
import { DesignService } from '../../core/services/design.service';
import { ProfileService } from '../../core/services/profile.service';
import Shepherd from 'shepherd.js';
import { NgForm } from '@angular/forms';
import { ReportBugFeedbackDTO } from 'src/app/core/models/reportBugFeedback.modal';

declare var $: any;
MultiSelect.Inject(CheckBoxSelection);

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss'],
  providers: [CheckBoxSelectionService],
})
export class HomepageComponent implements OnInit, OnDestroy {
  public selectedImg: any = '../../../assets/images/noprofile2.png'; // default snowman image set
  search = false; // flag to indicate if search operation performed.
  notFound = false; // flag to indicate that profile searched is not found.
  profileList = new Array<Profile>(); // Get Searched profile list
  searchValue = ''; // store value entered by user
  searchSuggetionList: any[] = [];
  trendingReviewList = new Array<Review>(); // store tranding review list
  trendingReviewActive = 'ALL';
  trendingReviewLoading = false; // Show Loading for tranding review
  navigation: any;
  recentSearch = new Array();
  recentFirst: boolean = false;
  categoryList = new Array<Category>();
  selectedCategoryId: number[] = []; // list of category
  selectedCategory = new Category();
  subcategoryList = new Array<Subcategory>(); // List of subcategory
  selectedSubcategoryId: number[] = []; // Used for getting the selected subcategories ID for multiselectdropdown
  subcategoryListForDataSource: any[] = [];
  selectedCategoryList = new Array<Category>(); // the subcategories that has been selected in the dropdown.
  categoryFilterList = new Array<string>();
  subCategoryFilterList = new Array<string>();
  user = new User(); // user that logged in
  private subscription: Subscription;
  value: any;
  showSuggestions: boolean = false;
  reportBugFeedbackDTO: ReportBugFeedbackDTO = new ReportBugFeedbackDTO();

  @ViewChild('multiselectcheckbox')
  public multiselectcheckbox!: CheckBoxSelection;

  options: NgxLinkifyOptions = {
    className: '',
    attributes(href: any, type: string) {
      type = 'linkify linkify-' + type;
      return { routerLink: href, class: type };
    },
    formatHref(href, type) {
      if (type === 'mention') {
        href = '/profile/view-profile/' + href.substring(1);
      }
      return href;
    },
    ignoreTags: ['script', 'style'],
    nl2br: true,
  };

  constructor(
    private profileService: ProfileService,
    private designService: DesignService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private loaderService: LoaderService,
    private title: Title,
    private meta: Meta,
    private userService : UserService
  ) {
    this.designService.setHeaderStyle('homepage'); // Set Header Style to homepage

    this.activatedRoute.data.subscribe(
      (success) => {
        // Retrive Category List
        if (+success['categoryList'].success === 0) {
          this.categoryList = success['categoryList'].data;
        } else {
          console.error(
            'TCL: HomepageComponent -> success.categoryList.error',
            success['categoryList'].error
          );
        }

        // Retrive searchResult
        if (success['searchResult']) {
          if (success['searchResult'].success === 0) {
            this.search = true;
            this.notFound = false;
            // this.profileList = success.searchResult.data;
            // const distinctThings = success.searchResult.data.filter(
            //   (thing, i, arr) => arr.findIndex((t) => t.profileName === thing.profileName) === i
            // );

            this.profileList = success['searchResult'].data;
            console.log(this.profileList);

            this.profileList.forEach((element) => {
              const temp: string = element.profileImage;
              if (temp != null) {
                console.log(
                  'Extension :' +
                    temp.substring(temp.lastIndexOf('.') + 1, temp.length)
                );
                if (
                  temp.substring(temp.lastIndexOf('.') + 1, temp.length) ===
                    'jpeg' ||
                  temp.substring(temp.lastIndexOf('.') + 1, temp.length) ===
                    'png' ||
                  temp.substring(temp.lastIndexOf('.') + 1, temp.length) ===
                    'jpg'
                ) {
                } else {
                  element.profileImage = '';
                }

                if (
                  element.profileImage.includes('bioguide.congress.gov') == true
                ) {
                  element.profileImage = '';
                }
              }
            });
            if (this.profileList.length === 0) {
              this.notFound = true;
            }
          } else {
            console.log(
              'TCL: HomepageComponent -> success.categoryList.error',
              success['searchResult'].error
            );
          }
        }
      },
      (error) => {
        console.log('TCL: HomepageComponent -> getCategories -> error', error);
      }
    );
   // this.getRecentSearch();

    this.navigation = this.router.getCurrentNavigation();
    this.subscription = this.activatedRoute.params.subscribe(
      (params: Params) => {
        this.searchValue = params['searchValue'];
        if (params['cat']) {
          setTimeout(() => {
            this.selectedCategoryId = params['cat'].split(',').map(Number);
            if (params['subcat']) {
              this.selectedSubcategoryId = params['subcat']
                .split(',')
                .map(Number);
            }
          }, 0);
        }
      }
    );
  }

  ngOnInit() {
    // const user = this.authService.getUser();
    this.user = this.authService.getUser();
    if (this.user != null && this.user.isTourDone == false && this.user.defaultProfileId != null) {
      this.startTour();
    }
    $('html, body').animate({ scrollTop: 0 }, '300');
    let reload: string;
    // if (this.navigation != null) {
    //   reload = this.navigation.extras.state ? this.navigation.extras.state.reload : false;
    //   if (reload) {
    //     this.router.navigateByUrl('/homepage', { state: { reload: false } });
    //     window.location.reload();
    //   } else {
    //     //this.getTrendingReviews();
    //   }
    // } else {
    //   //this.getTrendingReviews();
    // }
    localStorage.clear();
    this.title.setTitle('CitizeX');
    let description =
      'CitizeX is social networking service based on United states politicians where all levels of government politicians can interact with message known as "Post a Review." Verified politicians can give review and response, but unregistered politicians can only read them.';
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.removeTag('name= "keywords"');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  searchProfiles() {
    if (this.searchValue == undefined || this.searchValue === null) {
      return;
    } else {
      this.router.navigate(['/profile/view-profile/', this.searchValue]);
    }
  }

  selectEvent(value: any) {
    this.searchValue = value.tagName;
    this.searchProfiles();
  }

  onChangeSearch(event: string) {
    // Trim leading and trailing spaces
    const trimmedEvent = event.trim();
  
    // Prevent search if the trimmed string is empty
    if (trimmedEvent === '') {
      this.searchSuggetionList = []; // Clear suggestions if the search string is empty
     // this.searchProfiles(); // Optionally call searchProfiles if needed
      return;
    }
  
    // Update search value
    this.searchValue = trimmedEvent;
  
    // Check for minimum length
    if (trimmedEvent.length > 1) {
      // Remove '@' from the beginning if present
      let searchTerm = trimmedEvent.startsWith('@') ? trimmedEvent.slice(1) : trimmedEvent;
  
      let params = new HttpParams()
        .set('tagNameSubString', searchTerm)
        .set('limit', '20');
  
      if (this.user && this.user.defaultProfileId) {
        params = params.set('profileId', this.user.defaultProfileId.toString());
      }
  
      this.profileService.getSuggestions(params).subscribe(
        (success) => {
          const newList: { tagName: any; displayName: string }[] = [];
          this.recentFirst = false;
  
          success.data.forEach((element: any) => {
            const tag = '@' + element.tagName;
            const displayName = `${tag}<br>${element.publicName}`;
  
            // Ensure there are no duplicates in the suggestions list
            if (!newList.some((e) => e.tagName === element.tagName)) {
              newList.push({ tagName: element.tagName, displayName });
            }
          });
  
          // Update list and detect changes
          this.searchSuggetionList = newList;
          this.value = this.searchSuggetionList[0];
        },
        (error) => {
          console.error('Error On Search:', error);
        }
      );
    }
  }
  

  

  // to get trending reviews
  async getTrendingReviews() {
    this.trendingReviewActive = 'ALL';
    if (
      this.searchValue === undefined ||
      this.searchValue === null ||
      this.searchValue === ''
    ) {
      this.loaderService.disable = true;
      this.profileService.getTrendingReviews().subscribe(
        (success) => {
          this.trendingReviewList = success.data;
          this.trendingReviewLoading = true;
          if (!!this.trendingReviewList) {
            this.trendingReviewList.forEach((element) => {
              if (element.content.length >= 100) {
                element.content =
                  element.content +
                  "<button class='btn btn-link btn-link-theme read-more'>Read More</button>";
              }
            });
          }
        },
        (error) => {
          console.log('Error Loading Trending Reviews', error);
        }
      );
    }
  }

  getTrendingReviewsByLevel(type: string) {
    this.trendingReviewActive = type;

    const reviewDiv: any = document.querySelector('#reviewDiv');
    reviewDiv.style.height = `${reviewDiv.offsetHeight}px`;

    let levelStr: string = '';

    if (type === 'LOCAL') {
      levelStr = 'local';
    } else if (type === 'STATE') {
      levelStr = 'state';
    } else if (type === 'NATIONAL') {
      levelStr = 'national';
    }

    this.trendingReviewList = [];
    const params = new HttpParams()
      .set('level', levelStr)
      .set('profileId', this.user.defaultProfileId.toString());
    this.loaderService.disable = true;
    this.profileService.getReviewLevel(params).subscribe(
      (success) => {
        this.trendingReviewList = success.data;
        console.log(
          'TCL: HomepageComponent -> getTrendingReviewsByLevel -> success',
          success
        );
        this.trendingReviewLoading = true;
        if (!!this.trendingReviewList) {
          this.trendingReviewList.forEach((element) => {
            if (element.content.length >= 100) {
              element.content =
                element.content +
                "<button class='btn btn-link btn-link-theme read-more'>Read More</button>";
            }
          });
        }
        reviewDiv.style.height = 'auto';
      },
      (error) => {
        console.log('Error Loading Trending Reviews', error);
        reviewDiv.style.height = 'auto';
      }
    );
  }

  addToRecentSearch(value: string) {
    if (value !== undefined) {
      const user = this.authService.getUser();
      const params = new HttpParams()
        .set('searchString', value)
        .set('userId', user.userId)
        .set('profileId', user.defaultProfileId);
      // API call
      this.profileService.addToSearchHistory(params).subscribe((res) => {
        const respData = res;
        if (respData.success === 0) {
          console.log('search string added');
        }
      });
    }
  }

  getRecentSearch() {
    const user = this.authService.getUser();
    if (this.authService.getLogflag()) {
      const params = new HttpParams().set('userId', user.userId);
      // API call
      this.profileService.getRecentSearch(params).subscribe((res) => {
        const respData = res;
        if (respData.success === 0) {
          this.recentSearch = respData.data;
          this.searchSuggetionList = [];
          this.recentSearch.forEach((element) => {
            this.recentFirst = true;
            this.searchSuggetionList.push(element);
          });
        }
      });
    }
  }

  getSubcategories() {
    this.subcategoryListForDataSource = [];
    // Get Category list from category ids
    this.selectedCategoryId.forEach((element) => {
      var list = this.categoryList.find((x) => x.id == element);
      if (list != undefined) {
        this.selectedCategory = list;
      }

      // get subcategory list from selected category
      this.selectedCategory.subCategories.forEach((subElement) => {
        if (
          !this.subcategoryListForDataSource.some(
            (item) => item.subCategoryId === subElement.subCategoryId
          )
        ) {
          this.subcategoryListForDataSource.push({
            ...subElement,
            categoryName: this.selectedCategory.name,
            categoryId: element,
          });
        }
      });
    });
  }

  // Gets called on delete of Category dropdwon
  deleteCategory(event: { itemData: { id: any } }) {
    const rmId = event.itemData.id;
    const category = this.categoryList.find((x) => x.id === rmId);
    // get subcategory list from selected category
    if (category != undefined) {
      category.subCategories.forEach((subElement) => {
        if (
          this.selectedSubcategoryId.some(
            (item) => item === subElement.subCategoryId
          )
        ) {
          this.subcategoryList = this.subcategoryList.filter(
            (item) => item.subCategoryId !== subElement.subCategoryId
          );
          this.selectedSubcategoryId.splice(
            this.selectedSubcategoryId.indexOf(subElement.subCategoryId),
            1
          );
        }
      });
    }
    if (this.selectedCategoryId.length === 1) {
      this.subcategoryListForDataSource = [];
      this.selectedSubcategoryId = [];
    }
  }

  // Gets called on delete of Subcategory dropdown
  deleteSubCategory(event: { itemData: { subCategoryId: number } }) {
    // Logic for while subcategory is removed then all section related to that subcategory got deleted.
    this.subcategoryList = this.subcategoryList.filter(
      (item) => item.subCategoryId !== event.itemData.subCategoryId
    );
  }

  onEnter(event: any) {
    console.log('Enter key pressed', event);
    if (this.value != undefined) {
      this.router.navigate(['/profile/view-profile/', this.value.tagName]);
    }
  }
  startTour(){
    if (window.innerWidth < 768) {
      return; // Do not start the tour on mobile devices } 
    }
    const tour = new Shepherd.Tour({
      defaultStepOptions: {
        cancelIcon: {
          enabled: true
        },
        scrollTo: { behavior: 'smooth', block: 'center' }
      }
    });
  
    tour.addStep({
      text: 'Click here to start your first conversation',
      attachTo: {
        element: '#newPostReview',
        on: 'bottom'
      },
      buttons: [
        {
          action() {
            return this.next();
          },
          text: 'Next'
        }
      ],
      id: 'step-1'
    });

    // Second step
  tour.addStep({
    text: 'Search for elected officials and CitizeX users here',
    attachTo: {
      element: '#homeInput',
      on: 'bottom' 
    },
    buttons: [
      {
        text: 'Back',
        action() {
          return this.back();
        }
      },
      {
        action: () => {
          this.user.isTourDone = true;
          console.log(this.userService)
          this.updateUser(); // Calling your component's method
          $('#haveFeedbacks').modal('show');
          return tour.complete();
        },
        text: 'Finish'
      }
     
    ],
    classes:"custom-step-2",
    id: 'step-2'
  });
  
    tour.start();
  }

      // Purpose : For updating user
      updateUser() {
        this.userService.editUser(this.user).subscribe((res:any) => {
          this.authService.setSessionData(this.user);
          if (res.success == 0) {
            console.log('User updated successfully:' + JSON.stringify(this.user));
          } else {
            console.log('Error while updating user');
          }
        });
      }
  sendBugReportOrFeedback(form: NgForm) {
    if (form.invalid) {
      return;
    }
    this.reportBugFeedbackDTO.userId = this.user.userId;

    this.userService
      .sendBugReportOrFeedback(this.reportBugFeedbackDTO)
      .subscribe((res: any) => {
        const respData = res;
        if (respData.success == 0) {
          $('#haveFeedbacks').modal('hide');
          this.resetFormData(form);
        } else {
          $('#haveFeedbacks').modal('hide');
          this.resetFormData(form);
          console.log('Error while sending report bug or feedback');
        }
      });
  }

  resetFormData(form: NgForm) {
    form.resetForm();
    this.reportBugFeedbackDTO = new ReportBugFeedbackDTO();
  }

  onFocus() {
    this.showSuggestions = true;
  }

  // Hide suggestions when input loses focus
  onBlur() {
    // Delay hiding the suggestions to allow click events to register
    setTimeout(() => {
      this.showSuggestions = false;
    }, 200);
  }
}
